import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.map.js";
import fetch from 'cross-fetch';
/**
 * @module
 */

/**
 * Default basic method to POST list of events to query0 to publish into the right yak message channel
 * @param {Array} events - list of events to publish
 * @param {Object.<String, String>} headers - headers to include with the POST to query0
 * @param {Object} [options={}]
 * @param {String} [options.exchangeId='ANALYTIC_PIPELINE_MOUTH'] - Yak exchange id, gets used in POST body messages variable
 * @param {String} [options.operationName='PublishYakMessages'] - Operation to run on query0, gets built into options.query
 * @param {String} [options.field='publishYakMessages'] - Command to run on query0, gets built into options.query
 * @param {String} [options.query] - Query to send to query0
 * @param {String} [options.baseUrl] - the base URL of the query0 service
 *
 * @returns {Promise} - Promise object to resolve or reject with results of publish
 */

export default function transportQuery0(_x, _x2) {
  return _transportQuery.apply(this, arguments);
}

function _transportQuery() {
  _transportQuery = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(events, headers) {
    var options,
        _options$exchangeId,
        exchangeId,
        _options$operationNam,
        operationName,
        _options$field,
        field,
        _options$query,
        query,
        baseUrl,
        res,
        json,
        data,
        errors,
        error,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            // these options are configurable here so that tests can force yak to return an error
            // and that the error handling in this method can be asserted
            _options$exchangeId = options.exchangeId, exchangeId = _options$exchangeId === void 0 ? 'ANALYTIC_PIPELINE_MOUTH' : _options$exchangeId, _options$operationNam = options.operationName, operationName = _options$operationNam === void 0 ? 'PublishAnalyticsEvents' : _options$operationNam, _options$field = options.field, field = _options$field === void 0 ? 'publishYakMessages' : _options$field, _options$query = options.query, query = _options$query === void 0 ? "\n      mutation ".concat(operationName, "($messages: [YakMessageInput!]!) {\n        ").concat(field, "(messages: $messages) {\n          success\n        }\n      }\n    ") : _options$query, baseUrl = options.baseUrl;
            _context.next = 4;
            return fetch(baseUrl, {
              // Use `credentials: include` to allow for cross-origin requests to
              // include cookies. For example, when making a cross-origin request
              // from localnerd.nerdwallet.com to api.nerdwallet.biz, this allows
              // requests to include cookies set for api.nerdwallet.biz. Without
              // `credentials: include`, no cookies would be sent. This allows
              // local development against stage or prod query0.
              credentials: 'include',
              method: 'POST',
              headers: _objectSpread(_objectSpread({}, headers), {}, {
                'Content-Type': 'application/json'
              }),
              body: JSON.stringify({
                operationName: operationName,
                query: query,
                variables: {
                  messages: events.map(function (_ref) {
                    var eventType = _ref.eventType,
                        payload = _ref.payload;
                    return {
                      // Transform an analytics event into a YakMessageInput
                      exchangeId: exchangeId,
                      type: eventType,
                      payload: payload
                    };
                  })
                }
              })
            });

          case 4:
            res = _context.sent;
            _context.next = 7;
            return res.json();

          case 7:
            json = _context.sent;
            data = json.data, errors = json.errors;

            if (!errors) {
              _context.next = 15;
              break;
            }

            if (!(errors[0].extensions.code === 'MULTI_STATUS_ERROR')) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", errors[0].extensions.exception.results);

          case 12:
            error = new Error('transportQuery0 error');
            error.data = errors;
            throw error;

          case 15:
            return _context.abrupt("return", data[field]);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _transportQuery.apply(this, arguments);
}